export const ssKeys = {
	// Note: At least one image was successfully generated in previous generator's go
	IMG_GEN_PREV_SOME_SUCCESS: 'img-gen-prev-some-success',
	IMG_GEN_SUCCESS_GOES: 'img-gen-success-goes',
	IMG_GEN_REVIEW_ASKED: 'img-gen-review-asked',
	VIDEO_GEN_PREV_SOME_SUCCESS: 'video-gen-prev-some-success',
	VIDEO_GEN_SUCCESS_GOES: 'video-gen-success-goes',
	VIDEO_GEN_REVIEW_ASKED: 'video-gen-review-asked',
	CHAT_EXP_REVIEW_ASKED: 'chat-exp-review-asked',
	MARKERS: 'markers',
	G_TOOL_GENERATE_IN_PROGRESS: 'g-tool-generate-in-progress',
	ANNALS_SITE_VISIT_SENT: 'annals.site-visit-sent',
	GRID_FILTERS: 'grid.filters',
	GRID_FILTERS_DROPOUT: 'grid.filters.dropout',
	CONFIRM_EMAIL: 'confirm-email',
	// promocodes
	PROMOCODE: 'payment.default-promocode',
	CHAT_VIDEO_GEN_MODAL_HIDDEN: (userId: string) =>
		`video-gen-modal-hidden(${userId})`,
};

export const lsKeys = {
	CONFIRMATION_TOASTER_SHOWED: 'confirmation-toaster-showed',
	HIDE_EMAIL_CONFIRM_MODAL: 'hide_email_confirm_modal',
	EMAIL_CONFIRM_BANNER_POSTPONED_AT: 'emailConfirm.bannerPostponedAt',
	EMAIL_CONFIRM_MODAL_SHOWN: 'emailConfirm.modalShown',
	EMAIL_CONFIRM_LAST_SENT: 'emailConfirm.lastSent',
	G_TOOL_FREE_GEN_SHOWN: 'gtool.freeGenShown',
	FORCE_MODE_SWITCH: 'force.mode.switch',
	NEWS_MODAL_SHOWED: 'news.modal-showed',
};
